<div class="modal-content">
  <div class="modal__content modal__blueBackground">
    <div class="modal__header">
      <h3 *ngIf="!isBusinessMode" class="h3 modal__title modal__blueBackground">
        {{
          'sharedModule.bkgChangeUserModeDialog.titleChangeBusiness' | translate
        }}
      </h3>
      <h3 *ngIf="isBusinessMode" class="h3 modal__title modal__blueBackground">
        {{
          'sharedModule.bkgChangeUserModeDialog.titleChangeParticular'
            | translate
        }}
      </h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        attr.aria-label="{{ 'common.close' | translate }}"
      >
        <img src="assets/images/icons/close-inverse.svg" alt="" />
      </button>
    </div>

    <div class="modal__body">
      <bkg-dialog-banner
        [isVisible]="!!errorMessage"
        [message]="errorMessage"
        (closeBanner)="onCloseBanner()"
      >
      </bkg-dialog-banner>

      <ng-container *ngIf="!isBusinessMode">
        <div class="body-text">
          {{
            'sharedModule.bkgChangeUserModeDialog.bodyChangeBusiness'
              | translate
          }}
        </div>
        <form *ngIf="form" [formGroup]="form" errorTailor>
          <div class="form-group success">
            <label for="user-company" class="sr-only">{{
              'travelerStep.billingForm.profile' | translate
            }}</label>
            <ng-select
              class="billing-select"
              #selectUserCompany
              (change)="selectUserCompany.blur()"
              (change)="onSelectProfile($event)"
              formControlName="userCompany"
              id="user-company"
              [clearable]="false"
              [searchable]="false"
            >
              <ng-option
                *ngFor="let profile of companyProfiles"
                [value]="profile.id"
                >{{ profile.name }} <br />
                <div class="invisible-option-data">
                  <div class="billing-data-nif">{{ profile.nif }}</div>
                  <div class="billing-data-address">
                    {{ profile.address }} <br />
                    {{ profile.city }}
                  </div>
                </div>
              </ng-option>
            </ng-select>
          </div>
        </form>

        <button class="btn-secondary" (click)="selectCompanyProfile()">
          {{
            'sharedModule.bkgChangeUserModeDialog.btnChangeBusiness' | translate
          }}
        </button>

        <div class="link modal__blueBackground" (click)="onClickClose()">
          <a>
            {{
              'sharedModule.bkgChangeUserModeDialog.btnStayAsParticular'
                | translate
            }}
          </a>
        </div>
      </ng-container>

      <ng-container *ngIf="isBusinessMode">
        <div class="body-text">
          {{
            'sharedModule.bkgChangeUserModeDialog.bodyChangeParticular'
              | translate
          }}
        </div>
        <button class="btn-secondary" (click)="selectCompanyProfile('empty')">
          {{
            'sharedModule.bkgChangeUserModeDialog.btnChangeParticular'
              | translate
          }}
        </button>

        <div class="link modal__blueBackground" (click)="onClickClose()">
          <a>
            {{
              'sharedModule.bkgChangeUserModeDialog.btnStayAsBusiness'
                | translate
            }}
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</div>
